// src/utils/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";



const firebaseConfig = {
  apiKey: "AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc",
  authDomain: "portfolio-e79b8-5854c.firebaseapp.com",
  projectId: "portfolio-e79b8-5854c",
  storageBucket: "portfolio-e79b8-5854c.firebasestorage.app",
  messagingSenderId: "694813500771",
  appId: "1:694813500771:web:199c8f7e7795e560205f56",
  measurementId: "G-SBRW34PBBE",
  databaseURL: "https://portfolio-e79b8-5854c-default-rtdb.firebaseio.com",
};


const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export default app;
